import { REQUEST_DUPLICATE_CAMPAIGN, DUPLICATE_CAMPAIGN_SUCCESS, DUPLICATE_CAMPAIGN_ERROR } from './actionTypes';

export const requestDuplicateCampaign = () => ({ type: REQUEST_DUPLICATE_CAMPAIGN });

export const duplicateCampaignSuccess = campaign => ({ type: DUPLICATE_CAMPAIGN_SUCCESS, payload: campaign });

export const duplicateCampaignError = error => ({ type: DUPLICATE_CAMPAIGN_ERROR, payload: error });
